import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Chips from '../../../components/common/Chips';
import Typography from '../../../components/common/Typography';
import RadioOptionGroup from '../../../components/common/RadioOptionGroup';
import { relationOptions } from '../../../common/data';
import { nameRelation, setRegNumber } from '../../../common/Util';
import { updateItemSelectionInfo } from './itemSelectionSlice';

/*
    { label: t('itemSelectionOptions.option0'), key: 'htm074' }, // 소득요건
    { label: t('itemSelectionOptions.option1'), key: 'htm003' }, // 기본공제
    { label: t('itemSelectionOptions.option2'), key: 'htm010' }, // 의료비
    { label: t('itemSelectionOptions.option3'), key: 'htm009' }, // 보험료
    { label: t('itemSelectionOptions.option4'), key: 'htm011' }, // 교육비
    { label: t('itemSelectionOptions.option5'), key: 'htm014' }, // 기부금
    { label: t('itemSelectionOptions.option6'), key: 'htm012' }, // 신용카드
    { label: t('itemSelectionOptions.option7'), key: 'htm061' }, // 주택자금
    { label: t('itemSelectionOptions.option8'), key: 'htm062' }, // 연금
*/

const ItemCard = ({ data, handleChange, selectedIndex, filteredOptions, isDisabledList }) => {
  const { t } = useTranslation('deductions/itemSelection');
  const { t: tDependents } = useTranslation('dependents');

  return (
    <div className="itemCard">
      <div className="itemCardHeader">
        <div className="displayFlex" style={{ justifyContent: 'space-between' }}>
          <div>
            <Typography variant="body2Bold">{nameRelation(tDependents, data)}</Typography>
            <Typography variant="captionMedium">{setRegNumber(data?.htm001)}</Typography>
          </div>
        </div>
      </div>
      <div className="itemCardBody">
        {filteredOptions.map((option, index) => (
          <RadioOptionGroup
            style={{ flex: '0 0 calc(50% - 4px)' }}
            key={index}
            label={option.label}
            value={option.value}
            onChange={() => {
              if (option.key === 'htm003' || option.key === 'htm074') {
                return;
              }
              handleChange(selectedIndex, option.key, data[option.key] == '1' ? '3' : '1');
            }}
            checked={data[option.key] === '1'}
            isDisabled={option.key === 'htm003' || option.key === 'htm074'}
          />
        ))}
      </div>
      <div className="itemCardItemLine"></div>
      <div className="itemCardFooter">
        <Chips color="error">{t('card.chips')}</Chips>
        <Typography variant="captionMedium" color="error">
          {isDisabledList.map(option => option.label).join(', ')}
        </Typography>
      </div>
    </div>
  );
};

export default ItemCard;
